// Part F motion: insert one inert glow layer per card (the card pseudos are
// the pin + ring, so the fade needs an element).
export const initCardGlow = () => {
    const cards = document.querySelectorAll("#other-apps .other-app-card");
    if (cards.length === 0) {
        return;
    }
    cards.forEach(card => {
        if (card.querySelector(".other-app-card-glow") !== null) {
            return;
        }
        const glow = document.createElement("span");
        glow.className = "other-app-card-glow";
        glow.setAttribute("aria-hidden", "true");
        card.insertBefore(glow, card.firstChild);
    });
};
